export default "__VITE_ASSET__BP1FjG8J__"